module.exports = __webpack_public_path__ + "static/img/new-tag.2532bee1.png";